import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import EditText from './Icons/EditText.js';
import { Input, Modal, Button } from './index.js';
const EditReferenceId = (props) => {
    const lang = useSelector((s) => s.lang);
    const [updating, setUpdating] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [value, setValue] = useState('');
    const toggleModal = () => setEditModalOpen(!editModalOpen);
    useEffect(() => {
        props.value && setValue(props.value);
    }, [props.value]);
    const update = async () => {
        setUpdating(true);
        try {
            await props.onUpdate(value);
        }
        catch (err) {
            alert('Error');
            console.error(err);
        }
        setUpdating(false);
        setEditModalOpen(false);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(StyledEditText, { onClick: toggleModal, style: props.style }),
        editModalOpen && (React.createElement(Modal, { onToggle: toggleModal, header: props.placeholder },
            React.createElement(Input, { autofocus: true, placeholder: props.placeholder, value: value, onChange: (e) => {
                    setValue(e.target.value);
                }, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        update();
                    }
                } }),
            React.createElement("br", null),
            React.createElement(Button, { loading: updating, onClick: update, block: true }, lang.misc.save)))));
};
export default EditReferenceId;
const Wrapper = styled.div `
  padding-left: 8px;
  vertical-align: middle;
  display: inline-block;
`;
const StyledEditText = styled(EditText) `
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
//# sourceMappingURL=EditReferenceId.js.map